<template>
  <div class="results-page">
    <div class="results-fit">
      <div class="results-wrap" :style="canvasStyle">
        <img class="results_bg" :src="bgUrl" alt="" @load="onBgLoad" />
        <div class="results-overlay">
          <div v-if="info.logoImgUrl" class="results-logo-wrap">
            <img class="results_logo" :src="info.logoImgUrl" alt="" />
          </div>
          <div class="results-card" :class="{ 'has-logo': !!info.logoImgUrl }">
            <div class="cen_name">亲爱的 {{ studedntInfo.name || studentName }} 同学</div>
            <div class="cen_notice ql-editor" v-html="info.reportContent" v-if="info.reportContent"></div>
            <div v-if="studedntInfo.gradeId < 7 && !info.reportContent" class="cen_notice">
              请在家长的带领下，请于{{ info.reportStartTime }}到{{ studedntInfo.schoolName }}{{ studedntInfo.gradeName }}{{ studedntInfo.className }}报到。
            </div>
            <div v-if="studedntInfo.gradeId >= 7 && !info.reportContent" class="cen_notice">
              请于{{ info.reportStartTime }}分开始错时进校，按照报名须知里通知的时间到{{ studedntInfo.schoolName }}{{ studedntInfo.gradeName }}{{ studedntInfo.className }}报到。
            </div>
            <div class="cen_school">
              <div class="cen_school_inner">
                <span class="cen_school_name">{{ studedntInfo.schoolName }}</span>
                <img v-if="info.chapterImgUrl" class="results_zhang" :src="info.chapterImgUrl" alt="" />
                <div v-if="reportDateText" class="cen_report_time">{{ reportDateText }}</div>
              </div>
            </div>
          </div>
          <div class="hukklsgs" v-if="studedntInfo.classsQrcodeUrl">
            <img :src="'http://cdn.51xiaoping.com/' + studedntInfo.classsQrcodeUrl" class="qrcode-img" alt="" />
            <div>班级二维码，扫码进入班级群</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getInfoByIdCard, getSchoolConfig } from '@/api/home'
export default {
  data() {
    return {
      idcard: '',
      schoolId: -1,
      studentName: '',
      info: {},
      studedntInfo: {},
      reportStartTimeRaw: '',
      bgRatio: 750 / 1334,
      canvasW: 0,
      canvasH: 0
    }
  },
  computed: {
    bgUrl() {
      return this.info.backgroudImgUrl || require('../assets/img/lqbg.png')
    },
    reportDateText() {
      return this.formatReportDate(this.reportStartTimeRaw)
    },
    canvasStyle() {
      if (!this.canvasW || !this.canvasH) {
        return { width: '100%', height: '100%' }
      }
      return {
        width: this.canvasW + 'px',
        height: this.canvasH + 'px'
      }
    }
  },
  mounted() {
    this.updateCanvasSize()
    window.addEventListener('resize', this.updateCanvasSize)
    window.addEventListener('orientationchange', this.onOrientationChange)
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.updateCanvasSize)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateCanvasSize)
    window.removeEventListener('orientationchange', this.onOrientationChange)
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.updateCanvasSize)
    }
  },
  watch: {
    bgUrl() {
      this.$nextTick(() => {
        const img = this.$el && this.$el.querySelector('.results_bg')
        if (img && img.complete && img.naturalWidth) {
          this.onBgLoad({ target: img })
        } else {
          this.updateCanvasSize()
        }
      })
    }
  },
  created() {
    this.idcard = this.$route.query.idCard || ''
    this.studentName = this.$route.query.studentName || ''
    this.schoolId = this.$route.query.schoolId || -1
    this.getSchoolConfig()
  },
  methods: {
    onOrientationChange() {
      setTimeout(this.updateCanvasSize, 100)
    },
    onBgLoad(e) {
      const img = e.target
      if (img.naturalWidth && img.naturalHeight) {
        this.bgRatio = img.naturalWidth / img.naturalHeight
      }
      this.updateCanvasSize()
    },
    updateCanvasSize() {
      const viewport = window.visualViewport
      const vh = viewport ? viewport.height : window.innerHeight
      const vw = Math.min(viewport ? viewport.width : window.innerWidth, 750)
      const ratio = this.bgRatio || 750 / 1334
      let w
      let h
      if (vw / vh > ratio) {
        h = vh
        w = Math.round(vh * ratio)
      } else {
        w = vw
        h = Math.round(vw / ratio)
      }
      this.canvasW = w
      this.canvasH = h
    },
    formatReportDate(timeStr) {
      if (!timeStr) return ''
      let times = timeStr.replace(/\-/g, '/')
      let date = new Date(times)
      if (isNaN(date.getTime())) {
        const match = String(timeStr).match(/(\d{4})年(\d{1,2})月(\d{1,2})日/)
        return match ? match[1] + '年' + match[2] + '月' + match[3] + '日' : ''
      }
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = date.getDate()
      return y + '年' + m + '月' + d + '日'
    },
    formatReportTime(timeStr) {
      if (!timeStr) return ''
      let times = timeStr.replace(/\-/g, '/')
      let date = new Date(times)
      if (isNaN(date.getTime())) return timeStr
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = date.getDate()
      let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      let mf = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      return y + '年' + m + '月' + d + '日 ' + h + ':' + mf
    },
    getSchoolConfig() {
      getSchoolConfig({ schoolId: this.schoolId }).then((res) => {
        if (res.data.code != 0 && String(res.data.code) !== '0') {
          this.$toast(res.data.msg || '获取学校配置失败')
          return
        }
        let data = res.data.data || {}
        this.reportStartTimeRaw = data.reportStartTime || ''
        data.reportStartTime = this.formatReportTime(data.reportStartTime)
        this.info = data
        this.getInfoByIdCard()
      })
    },
    getInfoByIdCard() {
      if (!this.idcard || !this.studentName) return
      getInfoByIdCard({
        name: this.studentName,
        idCard: this.idcard
      }).then((res) => {
        if (res.data.code != 0 && String(res.data.code) !== '0') {
          this.$toast('未查询到您的信息！')
          return
        }
        const data = res.data.data
        if (!data || !data.name) {
          this.$toast('未查询到您的信息！')
          return
        }
        this.studedntInfo = data
        if (this.info.reportContent) {
          let content = this.info.reportContent
          content = content.replace(/\$\{报到时间\}/g, this.info.reportStartTime || '')
          content = content.replace(/\$\{班级\}/g, (this.studedntInfo.gradeName || '') + (this.studedntInfo.className || ''))
          this.info.reportContent = content
        }
      })
    }
  }
}
</script>
<style scoped>
.results-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  background-color: #22355d;
}
.results-fit {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.results-wrap {
  position: relative;
  flex-shrink: 0;
  overflow: hidden;
}
.results_bg {
  width: 100%;
  height: 100%;
  display: block;
  vertical-align: top;
  object-fit: fill;
}
.results-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.results-logo-wrap {
  position: absolute;
  top: 9.2%;
  left: 50%;
  transform: translateX(-50%);
  width: 48%;
  z-index: 2;
  line-height: 0;
  text-align: center;
}
.results_logo {
  display: block;
  max-height: 1.15rem;
  max-width: 100%;
  width: auto;
  height: auto;
  margin: 0 auto;
  object-fit: contain;
}
/* 固定对齐背景图米色通知书区域，高度不随内容变化 */
.results-card {
  position: absolute;
  top: 27%;
  left: 11%;
  right: 11%;
  bottom: 17%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding-top: 0.45rem;
  padding-bottom: 0.12rem;
  color: #333;
  font-size: 0.4rem;
  overflow: hidden;
}
.results-card.has-logo {
  top: 28%;
  padding-top: 0.38rem;
}
.cen_name {
  flex-shrink: 0;
  font-size: 0.43rem;
  font-weight: 600;
  line-height: 1.45;
}
.cen_notice {
  flex: 1;
  min-height: 0;
  margin-top: 0.16rem;
  padding: 0 0 3.1rem 0 !important;
  height: auto !important;
  line-height: 1.65;
  overflow: hidden !important;
  word-break: break-word;
  overflow-wrap: break-word;
  box-sizing: border-box;
}
.cen_notice:not(.ql-editor) {
  text-indent: 2em;
}
.cen_notice >>> p {
  text-indent: 2em;
}
.cen_school {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  padding-top: 0;
}
.cen_school_inner {
  position: relative;
  display: inline-block;
  max-width: 100%;
  padding: 0.28rem 0.72rem 0.06rem 0.12rem;
  text-align: right;
}
.cen_school_name {
  position: relative;
  z-index: 1;
  display: block;
  font-size: 0.4rem;
  font-weight: normal;
  line-height: 1.45;
}
.cen_report_time {
  position: relative;
  z-index: 1;
  margin-top: 0.1rem;
  font-size: 0.4rem;
  line-height: 1.45;
  white-space: nowrap;
}
.results_zhang {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1.65rem;
  height: auto;
  z-index: 2;
  pointer-events: none;
}
.hukklsgs {
  position: absolute;
  left: 50%;
  bottom: 6%;
  transform: translateX(-50%);
  color: #fff;
  font-size: 0.32rem;
  text-align: center;
  line-height: 1.5;
}
.qrcode-img {
  width: 2.2rem;
  display: block;
  margin: 0 auto 0.12rem;
}
</style>



// WEBPACK FOOTER //
// src/view/results.vue